import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Box,
  useDisclosure,
  Button,
  Text,
  Flex,
  Spinner,
  Stack,
  useToast
} from "@chakra-ui/react";
import "../css/PatientRecord.css";
import PatientRecordModal from "./modals/PatientRecordModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { callAddFont } from "../js/THSarabunNew-normal";

import moment from "moment";
import DatePickerWidget from "./DatePickerWidget";
import axios from "axios";
import { useAuth } from "../auth/AuthProvider";
import { server } from "../util/connect";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { th } from "date-fns/locale/th";
import html2canvas from "html2canvas";
import "../css/CustomTable.css";
import Swal from "sweetalert2";

const PatientRecord = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [records, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [unaddedTimeDoctors, setUnaddedTimeDoctors] = useState();
  const [unsavedDoctors, setUnsavedDoctors] = useState();
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [selectedRowIndex, setSelectedRowIndex] = useState();
  const [isDownloading, setDownloading] = useState(false);
  const [notes, setNotes] = useState([])

  useEffect(() => {
    const timerDuration = 300;
    const timerId = setTimeout(() => {
      if (user != null && user != undefined) {
        loadRecords(user.department_id, selectedDate);
      } else {
        navigate("/login");
      }
    }, timerDuration);

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timerId);
  }, [user]);

  useEffect(() => {
    if (selectedDate && user != null && user != undefined && user.department_id) {
      fetchNoteData();
    }
  }, [selectedDate, user])

  const fetchNoteData = async () => {
    const result = await axios.post(
      `${server}/note/fetch_valid_notes`,
      {
        department_id: user.department_id,
        today_date: moment(selectedDate).format("YYYY-MM-DD")
      }
    );
    setNotes(result.data.result);
  };

  const refreshTable = () => {
    loadRecords(user.department_id, selectedDate);
  };

  const checkUnaddedTimeData = (recs, isDaysBefore) => {
    var data = "";
    recs &&
      recs.map((r, index) => {
        if (
          !checkNull(r.start_diag_time) &&
          isDataAdded(r) &&
          !getOffType(r) &&
          !r.is_non_doctor &&
          isDaysBefore
        ) {
          data += data == "" ? r.doctor_name : ", " + r.doctor_name;
        }
      });
    setUnaddedTimeDoctors(data);
  };

  const checkSavedRecord = (recs, isDaysBefore) => {
    var data = "";
    recs &&
      recs.map((r, index) => {
        if (!checkNull(r.record_date) && isDaysBefore && !getOffType(r) && !r.is_non_doctor) {
          data += data == "" ? r.doctor_name : ", " + r.doctor_name;
        }
      });
    setUnsavedDoctors(data);
  };

  const loadRecords = (departmentId, date) => {
    setIsLoading(true);
    axios
      .post(`${server}/daily_record/list_doctor_records_by_department`, {
        department_id: departmentId,
        selected_date: date,
      })
      .then((response) => {
        setIsLoading(false);
        setRecords(response.data.records);

        const isDaysBefore = isTodayOrBefore(date);
        checkUnaddedTimeData(response.data.records, isDaysBefore);
        checkSavedRecord(response.data.records, isDaysBefore);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
      });
  };

  const setSelectedDay = (val) => {
    setSelectedDate(moment(val).format("YYYY-MM-DD"));
    loadRecords(user.department_id, val);
  };

  const handleRowClick = (index) => {
    setSelectedRowIndex(index);
    onOpen();
  };

  const getPDFTime = (e) => {
    const start = e.start_diag_time
      ? moment(e.start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.end_diag_time
      ? moment(e.end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return `${start}-${end}`;
  };

  const getPDFAdditionalTime = (e) => {
    const start = e.additional_start_diag_time
      ? moment(e.additional_start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.additional_end_diag_time
      ? moment(e.additional_end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return `${start}-${end}`;
  };

  const getAdditionalTime = (e) => {
    const start = e.additional_start_diag_time
      ? moment(e.additional_start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.additional_end_diag_time
      ? moment(e.additional_end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return (
      <Flex direction="column">
        <Text>{start}</Text>
        <Text>{end}</Text>
      </Flex>
    );
  };

  const getTime = (e) => {
    const start = e.start_diag_time
      ? moment(e.start_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    const end = e.end_diag_time
      ? moment(e.end_diag_time, "HH:mm:ss").format("HH:mm")
      : "";
    return (
      <Flex direction="column">
        <Text>{start}</Text>
        <Text>{end}</Text>
      </Flex>
    );
  };

  const checkNull = (val) => {
    return val == undefined || val == "" || val == 0 ? "" : val;
  };

  const calculateTotalSum = (columnName) => {
    return records.reduce((sum, record) => {
      return sum + (record[columnName] || 0);
    }, 0);
  };

  const getOffType = (r) => {
    return r.is_skipted
      ? "(งด)"
      : r.has_additional_period
        ? "(ชด)"
        : r.start_time && r.end_time
          ? ""
          : r.start_diag_time && r.end_diag_time
            ? ""
            : r.old_o_case || r.new_o_case || r.old_r_case || r.new_r_case
              ? ""
              : r.is_non_doctor
                ? ""
                : "(หยุด)";
  };

  const exportToPDF = () => {
    setDownloading(true);
    jsPDF.API.events.push(["addFonts", callAddFont]);

    const pdf = new jsPDF("landscape");
    pdf.setFont("THSarabunNew", "normal");
    pdf.text(
      10,
      10,
      `สรุปยอดประจำวัน ${user.department} (${format(selectedDate, "EEEE dd MMMM yyyy", { locale: th })})`
    );

    const columns = [
      "แพทย์",
      "O+R",
      "O Old",
      "O New",
      "R Old",
      "R New",
      "Lab",
      "X-Ray",
      "EKG",
      "ABI",
      "Obesity",
      "Treat.",
      "Refer",
      "CT",
      "PFT",
      "ให้เลือด",
      "OR",
      "Chemo",
      "B.letting",
      "จ.ปอด",
      "จ.ไขกระดูก",
      "V. RSV",
      "V. Flu",
      "V. IPD",
      "V. Dengue",
      "V. Zoster",
      "O Adm.",
      "R Adm.",
      "Adm. Total",
      "Check up",
      "ว.ตรวจจริง",
      "ว.ออกชด",
    ];

    const rows = records.map((e) => [
      e.doctor_name + " " + getOffType(e),
      e.is_skipted
        ? ""
        : checkNull(e.new_o_case + e.new_r_case + e.old_o_case + e.old_r_case),
      e.is_skipted ? "" : checkNull(e.old_o_case),
      e.is_skipted ? "" : checkNull(e.new_o_case),
      e.is_skipted ? "" : checkNull(e.old_r_case),
      e.is_skipted ? "" : checkNull(e.new_r_case),
      e.is_skipted ? "" : checkNull(e.lab_num),
      e.is_skipted ? "" : checkNull(e.xray_num),
      e.is_skipted ? "" : checkNull(e.ekg_num),
      e.is_skipted ? "" : checkNull(e.abi_num),
      e.is_skipted ? "" : checkNull(e.obesity_num),
      e.is_skipted ? "" : checkNull(e.treatment_num),
      e.is_skipted ? "" : checkNull(e.refer_num),

      // ⭐ ฟิลด์ใหม่
      e.is_skipted ? "" : checkNull(e.ct_num),
      e.is_skipted ? "" : checkNull(e.pft_num),
      e.is_skipted ? "" : checkNull(e.blood_transfusion_num),
      e.is_skipted ? "" : checkNull(e.or_num),
      e.is_skipted ? "" : checkNull(e.chemo_num),
      e.is_skipted ? "" : checkNull(e.blood_letting_num),
      e.is_skipted ? "" : checkNull(e.lung_tap_num),
      e.is_skipted ? "" : checkNull(e.bone_marrow_tap_num),
      e.is_skipted ? "" : checkNull(e.vacc_rsv_num),

      e.is_skipted ? "" : checkNull(e.vacc_flu_num),
      e.is_skipted ? "" : checkNull(e.vacc_ipd_num),
      e.is_skipted ? "" : checkNull(e.vacc_dengue_num),
      e.is_skipted ? "" : checkNull(e.vacc_zoster_num),
      e.is_skipted ? "" : checkNull(e.admit_o_case),
      e.is_skipted ? "" : checkNull(e.admit_r_case),
      e.is_skipted ? "" : checkNull(e.admit_o_case + e.admit_r_case),
      e.is_skipted ? "" : checkNull(e.check_up),
      e.is_skipted ? "" : getPDFTime(e),
      e.has_additional_period ? "" : getPDFAdditionalTime(e),
    ]);

    rows.push([
      "รวม",
      calculateTotalSum("new_o_case") +
      calculateTotalSum("new_r_case") +
      calculateTotalSum("old_o_case") +
      calculateTotalSum("old_r_case"),
      calculateTotalSum("old_o_case"),
      calculateTotalSum("new_o_case"),
      calculateTotalSum("old_r_case"),
      calculateTotalSum("new_r_case"),
      calculateTotalSum("lab_num"),
      calculateTotalSum("xray_num"),
      calculateTotalSum("ekg_num"),
      calculateTotalSum("abi_num"),
      calculateTotalSum("obesity_num"),
      calculateTotalSum("treatment_num"),
      calculateTotalSum("refer_num"),

      // ⭐ total ฟิลด์ใหม่
      calculateTotalSum("ct_num"),
      calculateTotalSum("pft_num"),
      calculateTotalSum("blood_transfusion_num"),
      calculateTotalSum("or_num"),
      calculateTotalSum("chemo_num"),
      calculateTotalSum("blood_letting_num"),
      calculateTotalSum("lung_tap_num"),
      calculateTotalSum("bone_marrow_tap_num"),
      calculateTotalSum("vacc_rsv_num"),

      calculateTotalSum("vacc_flu_num"),
      calculateTotalSum("vacc_ipd_num"),
      calculateTotalSum("vacc_dengue_num"),
      calculateTotalSum("vacc_zoster_num"),
      calculateTotalSum("admit_o_case"),
      calculateTotalSum("admit_r_case"),
      calculateTotalSum("admit_o_case") + calculateTotalSum("admit_r_case"),
      calculateTotalSum("check_up"),
      "",
      "",
    ]);

    const margin = 5;
    pdf.autoTable({
      head: [columns],
      body: rows,
      startY: 15,
      theme: "grid",
      margin: { top: margin + 4, left: margin, right: margin, bottom: margin },
      styles: {
        font: "THSarabunNew",
        fontSize: 8,
        cellPadding: 1,
        cellWidth: "wrap",
        overflow: "ellipsize"
      },
      headStyles: { fillColor: [0, 84, 168] },
    });

    pdf.save(
      `daily stat ${selectedDate} ${moment(new Date()).format("HHmmss")}.pdf`
    );
    setDownloading(false);
  };

  const onModalClose = () => {
    setSelectedRowIndex(undefined);
    onClose();
  };

  function isTodayOrBefore(date) {
    const inputDate = moment(date, "YYYY-MM-DD", true);

    if (!inputDate.isValid()) {
      throw new Error("Invalid date format. Please use YYYY-MM-DD.");
    }

    const today = moment();
    return inputDate.isSameOrBefore(today, "day");
  }

  const isDataAdded = (r) => {
    return checkNull(r.start_diag_time) ||
      checkNull(r.old_o_case) ||
      checkNull(r.new_o_case) ||
      checkNull(r.old_r_case) ||
      checkNull(r.new_r_case)
      ? true
      : false;
  };

  const handleImageClick = () => {
    const notificationsMessage = notes
      .map((n) => `วัน${format(n.due_date, "EEEE ที่ dd MMMM yyyy", { locale: th })} <br><br>${n.note}<br><br><hr>`)
      .join("\n");

    // Use SweetAlert2 to show a single alert with all notifications
    Swal.fire({
      title: "แจ้งเตือน",
      html: notificationsMessage,
      icon: "info",
      showCancelButton: false,
      showConfirmButton: true,
      confirmButtonText: "ตกลง",
    });
  };

  return user ? (
    <Box mt={2}>
      <DatePickerWidget
        setSelectedDay={setSelectedDay}
      />

      <Box
        mb={1}
        mt={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex direction={"column"} w="1300px">
          {unaddedTimeDoctors && (
            <Flex
              w="100%"
              bgColor={"blue.50"}
              borderColor="gray.300"
              borderWidth={1}
              py={1}
              align={"center"}
              direction={"row"}
              justify={"center"}
            >
              <Text fontSize={11} fontWeight={600}>
                ยังไม่บันทึกเวลา: {unaddedTimeDoctors}
              </Text>
            </Flex>
          )}

          {unsavedDoctors && (
            <Flex
              mt={1}
              w="100%"
              bgColor={"orange.50"}
              borderColor="gray.300"
              borderWidth={1}
              py={1}
              justify={"center"}
              align={"center"}
              direction={"row"}
            >
              <Text fontSize={11} fontWeight={600}>
                ยังไม่บันทึกข้อมูล: {unsavedDoctors}
              </Text>
            </Flex>
          )}
        </Flex>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center">
        <PatientRecordModal
          refreshTable={refreshTable}
          curdate={selectedDate}
          recordData={records[selectedRowIndex]}
          isOpen={isOpen}
          onClose={onModalClose}
        />

        <Box
          w={"1300px"}
          overflowX="auto"
          css={{
            "&::-webkit-scrollbar": {
              height: "6px", // Set width of the scrollbar
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#a0aec0", // Set color of the scrollbar thumb
            },
          }}
        >
          <Box position="relative" alignItems="center" justifyContent="center">
            <Table h="40px" size="xs" id="pdf-table" className="custom-table">
              <Thead>
                <Tr>
                  <Th px={2} minW={"100px"}>แพทย์</Th>
                  <Th px={2}>O+R</Th>
                  <Th px={2}>O Old</Th>
                  <Th px={2}>O New</Th>
                  <Th px={2}>R Old</Th>
                  <Th px={2}>R New</Th>
                  <Th px={2}>Lab</Th>
                  <Th px={2}>X-Ray</Th>
                  <Th px={2}>EKG</Th>
                  <Th px={2}>ABI</Th>
                  <Th px={2}>Obesity</Th>
                  <Th px={2}>Treat.</Th>
                  <Th px={2}>Refer</Th>

                  <Th px={2}>CT</Th>
                  <Th px={2}>PFT</Th>
                  <Th px={2}>ให้เลือด</Th>
                  <Th px={2}>OR</Th>
                  <Th px={2}>Chemo</Th>
                  <Th px={2}>Blood letting</Th>
                  <Th px={2}>เจาะปอด</Th>
                  <Th px={2}>เจาะไขกระดูก</Th>
                  <Th px={2}>V. RSV</Th>

                  <Th px={2}>V. Flu</Th>
                  <Th px={2}>V. IPD</Th>
                  <Th px={2}>V. Dengue</Th>
                  <Th px={2}>V. Zoster</Th>
                  <Th px={2}>O Adm.</Th>
                  <Th px={2}>R Adm.</Th>
                  <Th px={2}>Adm. Total</Th>
                  <Th px={2}>Check up</Th>
                  <Th px={2}>เวลาตรวจ</Th>
                  <Th px={2}>เวลาออกชด</Th>
                </Tr>
              </Thead>
              <Tbody>
                {records.map((e, index) => (
                  <Tr
                    h={"45px"}
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => handleRowClick(index)}
                  >
                    <Td>
                      <Flex px={2}>
                        {e.doctor_name}
                        {e.is_skipted ? (
                          <Text ml={2} color="red.500">
                            (งด)
                          </Text>
                        ) : e.has_additional_period ? (
                          <Text ml={2} color="blue.500">
                            (ชด)
                          </Text>
                        ) : e.start_time && e.end_time ? (
                          <Text></Text>
                        ) : e.start_diag_time && e.end_diag_time ? (
                          <Text></Text>
                        ) : e.old_o_case || e.new_o_case || e.old_r_case || e.new_r_case ? (
                          <Text></Text>
                        )
                          : e.is_non_doctor ? (
                            <Text></Text>
                          )
                            : (
                              <Text ml={2} color="orange.400">
                                (หยุด)
                              </Text>
                            )}
                      </Flex>
                    </Td>
                    <Td>
                      {!e.is_skipted &&
                        checkNull(
                          e.new_o_case +
                          e.new_r_case +
                          e.old_o_case +
                          e.old_r_case
                        )}
                    </Td>
                    <Td>{!e.is_skipted && checkNull(e.old_o_case)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.new_o_case)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.old_r_case)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.new_r_case)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.lab_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.xray_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.ekg_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.abi_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.obesity_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.treatment_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.refer_num)}</Td>

                    <Td>{!e.is_skipted && checkNull(e.ct_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.pft_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.blood_transfusion_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.or_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.chemo_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.blood_letting_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.lung_tap_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.bone_marrow_tap_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.vacc_rsv_num)}</Td>

                    <Td>{!e.is_skipted && checkNull(e.vacc_flu_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.vacc_ipd_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.vacc_dengue_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.vacc_zoster_num)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.admit_o_case)}</Td>
                    <Td>{!e.is_skipted && checkNull(e.admit_r_case)}</Td>
                    <Td>
                      {!e.is_skipted &&
                        checkNull(e.admit_o_case + e.admit_r_case)}
                    </Td>
                    <Td>{!e.is_skipted && checkNull(e.check_up)}</Td>
                    <Td>{!e.is_skipted && getTime(e)}</Td>
                    <Td>{e.has_additional_period ? getAdditionalTime(e) : ""}</Td>
                  </Tr>
                ))}

                <Tr h={"45px"}>
                  <Td>รวม</Td>
                  <Td>
                    {calculateTotalSum("new_o_case") +
                      calculateTotalSum("new_r_case") +
                      calculateTotalSum("old_o_case") +
                      calculateTotalSum("old_r_case")}
                  </Td>
                  <Td>{calculateTotalSum("old_o_case")}</Td>
                  <Td>{calculateTotalSum("new_o_case")}</Td>
                  <Td>{calculateTotalSum("old_r_case")}</Td>
                  <Td>{calculateTotalSum("new_r_case")}</Td>
                  <Td>{calculateTotalSum("lab_num")}</Td>
                  <Td>{calculateTotalSum("xray_num")}</Td>
                  <Td>{calculateTotalSum("ekg_num")}</Td>
                  <Td>{calculateTotalSum("abi_num")}</Td>
                  <Td>{calculateTotalSum("obesity_num")}</Td>
                  <Td>{calculateTotalSum("treatment_num")}</Td>
                  <Td>{calculateTotalSum("refer_num")}</Td>

                  <Td>{calculateTotalSum("ct_num")}</Td>
                  <Td>{calculateTotalSum("pft_num")}</Td>
                  <Td>{calculateTotalSum("blood_transfusion_num")}</Td>
                  <Td>{calculateTotalSum("or_num")}</Td>
                  <Td>{calculateTotalSum("chemo_num")}</Td>
                  <Td>{calculateTotalSum("blood_letting_num")}</Td>
                  <Td>{calculateTotalSum("lung_tap_num")}</Td>
                  <Td>{calculateTotalSum("bone_marrow_tap_num")}</Td>
                  <Td>{calculateTotalSum("vacc_rsv_num")}</Td>

                  <Td>{calculateTotalSum("vacc_flu_num")}</Td>
                  <Td>{calculateTotalSum("vacc_ipd_num")}</Td>
                  <Td>{calculateTotalSum("vacc_dengue_num")}</Td>
                  <Td>{calculateTotalSum("vacc_zoster_num")}</Td>
                  <Td>{calculateTotalSum("admit_o_case")}</Td>
                  <Td>{calculateTotalSum("admit_r_case")}</Td>

                  <Td>
                    {calculateTotalSum("admit_o_case") +
                      calculateTotalSum("admit_r_case")}
                  </Td>
                  <Td>{calculateTotalSum("check_up")}</Td>
                  <Td></Td>
                  <Td></Td>
                </Tr>
              </Tbody>
            </Table>
            {isLoading && (
              <Flex
                top={0}
                left={0}
                position="absolute"
                bgColor={"gray.200"}
                w={"100%"}
                h={"100%"}
              ></Flex>
            )}
            {isLoading && (
              <Box
                p={2}
                borderColor={"black"}
                borderRadius={"8px"}
                bgColor={"white"}
                position="absolute"
                top="30%"
                left="50%"
                transform="translate(-50%, -50%)"
                zIndex="1"
              >
                <Flex align={"center"}>
                  {" "}
                  <Spinner mr={2} />
                  Loading...
                </Flex>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box
        mb={6}
        mt={5}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Flex direction={"column"} w="1300px">
          <Flex mt={2} justify={"center"}>
            {user && !isDownloading && (
              <Button
                size={"sm"}
                colorScheme="green"
                variant={"ghost"}
                onClick={exportToPDF}
              >
                Export to PDF
              </Button>
            )}
            {isDownloading && (
              <Flex>
                <Spinner />
                <Text ml={2}>downloading...</Text>
              </Flex>
            )}
          </Flex>
        </Flex>
      </Box>

      {notes && notes.length > 0 && <Box
        position="fixed"
        top="73px"
        right="1px"
        ml={0}
        mb={4}
        zIndex="2"
        cursor={"pointer"}
        onClick={handleImageClick}
      >
        <img
          src="/images/notification.gif" // Replace with the actual path to your image
          alt="notification image"
          width="50px" // Adjust the width as needed
          height="50px" // Adjust the height as needed
        />
      </Box>}

    </Box>
  ) : (
    <Spinner />
  );
};

export default PatientRecord;
